export const TRANSACTION_CONFIG = {
  payment: {
    in: {
      bgColor: '#E7E7FE',
      color: '#110DF2',
      name: 'money-plus',
    },
    out: {
      bgColor: '#F7E3DE',
      color: '#863522',
      name: 'money-minus',
    },
  },
  account_creation_fee: {
    in: {
      bgColor: '#DFFBE6',
      color: '#00B530',
      name: 'arrow-line-down',
    },
    out: {
      bgColor: '#FDE9E7',
      color: '#F04C41',
      name: 'arrow-line-up',
    },
  },
  transfer: {
    in: {
      bgColor: '#FCE9F9',
      color: '#EB7AD9',
      name: 'user-plus',
    },
    out: {
      bgColor: '#FEEFE6',
      color: '#F98040',
      name: 'user-minus',
    },
  },
  expense_bonus: {
    in: {
      bgColor: '#EFE7FE',
      color: '#9258F7',
      name: 'rewards',
    },
  },
  award: {
    in: {
      bgColor: '#EFE7FE',
      color: '#9258F7',
      name: 'rewards',
    },
  },
  partner_payment: {
    in: {
      bgColor: '#DFFBE6',
      color: '#00B530',
      name: 'arrow-line-down',
    },
    out: {
      bgColor: '#FDE9E7',
      color: '#F04C41',
      name: 'arrow-line-up',
    },
  },
  withdrawal: {
    in: {
      bgColor: '#E7E7FE',
      color: '#110DF2',
      name: 'money-plus',
    },
    out: {
      bgColor: '#F7E3DE',
      color: '#863522',
      name: 'money-minus',
    },
  },
  ad_tax_hold_deposit: {
    in: {
      bgColor: '#D9E9F2',
      color: '#367BA5',

      name: 'time-arrow-down',
    },
    out: {
      bgColor: '#E9E9E2',
      color: '#6F6E46',
      name: 'time-arrow-up',
    },
  },
  ad_tax_refund_deposit: {
    in: {
      bgColor: '#DEE0ED',
      color: '#2E3351',

      name: 'percent-arrow-down',
    },
    out: {
      bgColor: '#FADBDB',
      color: '#EA6164',
      name: 'percent-arrow-up',
    },
  },
  ad_tax_hold_withdrawal: {
    in: {
      bgColor: '#D9E9F2',
      color: '#367BA5',

      name: 'time-arrow-down',
    },
    out: {
      bgColor: '#E9E9E2',
      color: '#6F6E46',
      name: 'time-arrow-up',
    },
  },
  ad_tax_payment: {
    in: {
      bgColor: '#DEE0ED',
      color: '#2E3351',
      name: 'bag-plus',
    },
    out: {
      bgColor: '#FADBDB',
      color: '#EA6164',
      name: 'bag-minus',
    },
  },
  bank_card_issue: {
    in: {
      bgColor: '#F8E3EF',
      color: '#B81476',
      name: 'discount',
    },
    out: {
      bgColor: '#F8E3EF',
      color: '#B81476',
      name: 'discount',
    },
  },
  bank_card_transaction: {
    in: {
      bgColor: '#E4F2EF',
      color: '#3A786E',
      name: 'card-arrow-down',
    },
    out: {
      bgColor: '#EBE9ED',
      color: '#544959',
      name: 'card-arrow-up',
    },
  },
}
